import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';
import * as Sentry from '@sentry/angular-ivy';
import package_json from '../package.json';
import posthog from 'posthog-js';

try {
    Sentry.init({
        release: package_json['version'],
        environment: environment.production ? 'production' : 'debug',
        dsn: 'https://04cbe05dbd88d773fe43c9220d124e14@o992304.ingest.sentry.io/4506692760698880',
        integrations: [],
    });

    if (!window.location.host.includes('127.0.0.1') && !window.location.host.includes('localhost')) {
        posthog.init('phc_jpCf6qDJwCkYaeHXiJvenv0Ngh0JkH7IUi1FkgkaNhJ', {
            api_host: 'https://us.i.posthog.com',
            person_profiles: 'identified_only',
            autocapture: false,
            capture_pageview: false
        })
    }
} catch (err) {
    console.error(err);
    alert(`Something went wrong! ${err.toString()}`);
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => {
        console.error(err);
        alert(`Caught an error! ${err.toString()}`);
    });
